import { render, staticRenderFns } from "./ContactsEmergenciesInformation.vue?vue&type=template&id=0d98c215"
import script from "./ContactsEmergenciesInformation.vue?vue&type=script&lang=js"
export * from "./ContactsEmergenciesInformation.vue?vue&type=script&lang=js"
import style0 from "./ContactsEmergenciesInformation.vue?vue&type=style&index=0&id=0d98c215&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports